<template>
  <div>
    <div class="category-title">审批记录</div>
    <yl-table :columns="columns" :data="pageResult" :size="size" @findPage="findPage">

    </yl-table>
  </div>
</template>

<script>
import YlTable from '../Core/YlTable';
import {buildEntitesIndexX, getMemberFlowStatusEntities} from '../../utils/entities';

export default {
  name: 'ApproveLog',
  components: {YlTable},
  props: {
    formData:{
      type: Object,
    },
    formId: {
      type: String,
    },
    type: {
      type: Number,
    },
  },
  data() {
    let flowStatusEntities = getMemberFlowStatusEntities();
    buildEntitesIndexX(flowStatusEntities, 'value');
    return {
      flowStatusEntities: flowStatusEntities,
      size: 'small',
      pageResult: {},
      filters: {},
      pageRequest: {
        pageNum: 0,
        pageSize: 10,
      },
      columns: [
        {prop: 'createTime', label: '操作时间', width: 140},
        {prop: 'createUserName', label: '操作人', width: 120},
        {prop: 'status', label: '操作', minWidth: 150, formatter: this.formatFlowStatus},
        {prop: 'opinion', label: '意见', minWidth: 300,align:"left"},
      ],
    };
  },
  watch: {
    formId: function() {
      this.findPage(null);
    },
    formData: function() {
      this.findPage(null);
    },
  },
  methods: {
    formatFlowStatus(row, column, value) {
      var row = this.flowStatusEntities[value];
      if (row) {
        return row.operateName;
      }
    },
    findPage(data) {
      console.log(this.formData)
      if (!this.formId) {
        this.pageResult.list = [];
        if (data && data.callback) {
          data.callback();
        }
        return;
      }
      if (data) {
        this.pageRequest = data.pageRequest;
      } else {
        this.pageRequest.pageNum = 0;
      }
      this.pageRequest.columnFilters = Object.assign({}, this.filters, {formId: this.formId, type: this.type});
      this.$api.deptExtend.getFlowApprovalByCondition(this.pageRequest).then((res) => {
        this.pageResult = res.data;
      }).then(data != null ? data.callback : '');
    },
  },
  mounted() {

    this.findPage(null);
  }
};
</script>

<style scoped>
.category-title {
  text-align: left;
  font-size: 16px;
  border-bottom: 1px solid #053e99;
  padding-bottom: 5px;
  margin-bottom: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Member/ApproveLog.vue